import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #08aeea;
  background-image: linear-gradient(324deg, #08aeea 0%, #2af598 100%);
`;

export default Container;
